import React from 'react';
import Link from '@cloudscape-design/components/link';
import { useNavigate } from 'react-router-dom';

interface Props {
  causedBy?: string | string[] | null;
  /**
   * If provided, clicking the chip is treated as a local selection first
   * (the parent tries to highlight the event in the current view). Otherwise
   * — or if the parent's onSelect can't find the event locally — the chip
   * navigates to the store's lineage graph, which resolves cross-store.
   */
  onSelect?: (eventId: string) => void;
  storeName?: string;
}

export function CausedByChip({ causedBy, onSelect, storeName }: Props) {
  const navigate = useNavigate();
  if (!causedBy || (Array.isArray(causedBy) && causedBy.length === 0)) return <span>—</span>;

  const ids = Array.isArray(causedBy) ? causedBy : [causedBy];

  return (
    <span>
      {ids.map((id, i) => {
        // Real href so right-click "Open in new tab" works and screen readers
        // can describe the destination. onFollow keeps SPA navigation on
        // plain click; if a parent provides onSelect, prefer local highlight.
        const href = storeName ? `/stores/${storeName}/lineage/${id}` : undefined;
        return (
          <span key={id}>
            {i > 0 && ', '}
            <Link
              href={href}
              onFollow={(e) => {
                e.preventDefault();
                if (onSelect) {
                  onSelect(id);
                } else if (href) {
                  navigate(href);
                }
              }}
              fontSize="body-s"
            >
              → {id.substring(0, 8)}…
            </Link>
          </span>
        );
      })}
    </span>
  );
}
